/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: true, // Change this to true if you want to use the splash screen.
  useCustomCursor: true, // Change this to false if you want the good'ol cursor
};

//Home Page
const greeting = {
  title: "Hi",
  title2: " I'm Bhupesh Khedikar",
  logo_name: "<Bhupesh Khedikar />",
  // nickname: "harry / picleric",
  full_name: "Bhupesh Khedikar",
  subTitle1: "React ⚛️ Developer ",
  subTitle2: "Life Long Learner.",
  subTitle: "Software Developer, Life Long Learner.",
  resumeLink:
    "https://drive.google.com/file/d/1l7fNh6RBl5k2EMFFhy3xVjk6revZ-uQT/view?usp=sharing",
  mail: "mailto:bhupeshkhedikar1999@gmail.com",
};

const socialMediaLinks = {
  /* Your Social Media Link */
  github: "https://github.com/bhupeshkhedikar",
  linkedin: "https://www.linkedin.com/in/bhupesh-khedikar",
  gmail: "bhupeshkhedikar1999@gmail.com",
  twitter: "https://twitter.com/bhupeshkhedikar",
};

const skills = {
  data: [
    {
      _id: "354c54b7-ffd8-40f1-972f-1d006733df25",
      title: "React ⚛️ Developer",
      fileName: "FullStackImg",
      skills: [
        "⚡ Proficiency in ReactJS, Redux, React Router, and other popular React libraries",
        "⚡ Develop highly interactive user interfaces for web applications",
        "⚡ Building responsive website front end using React Js",
        "⚡ Experience working with APIs and integrating them into React applications",
        "⚡ Integration of third party services such as Firebase, Vercel,Netlify etc.",
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "logos:javascript",
          style: {
            backgroundColor: "#FFFFFF",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "Redux",
          fontAwesomeClassname: "simple-icons:redux",
          style: {
            color: "#593D88",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "simple-icons:node-dot-js",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "Material UI",
          fontAwesomeClassname: "simple-icons:uikit",
          style: {
            color: "#007FFF",
          },
        },
        {
          skillName: "Styled Components",
          fontAwesomeClassname: "vscode-icons:file-type-styled",
          style: {
            color: "#635BFF",
            width: "1em",
            height: "1em",
          },
        },
        {
          skillName: "Bootstrap",
          fontAwesomeClassname: "simple-icons:bootstrap",
          style: {
            color: "#563d7c",
          },
        },
        {
          skillName: "Postman",
          fontAwesomeClassname: "simple-icons:postman",
          style: {
            color: "#FF6C37",
          },
        },
        {
          skillName: "NPM",
          fontAwesomeClassname: "simple-icons:npm",
          style: {
            color: "#CB3837",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#439743",
          },
        },
        {
          skillName: "MySQL",
          fontAwesomeClassname: "simple-icons:mysql",
          style: {
            color: "#4479A1",
          },
        },
        {
          skillName: "Git",
          fontAwesomeClassname: "simple-icons:git",
          style: {
            color: "#E94E32",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "simple-icons:python",
          style: {
            color: "#3776AB",
          },
        },
      ],
    },
    {
      _id: "c026fe64-1542-42b0-84ab-9311840c169f",
      title: "Infra-Architecture",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Experience working on multiple cloud platforms",
        "⚡ Experience hosting and managing websites",
        "⚡ Experience with Continuous Integration",
      ],
      softwareSkills: [
        {
          skillName: "Google Cloud Platform",
          fontAwesomeClassname: "skill-icons:gcp-dark",
          style: {
            backgroundColor: "transparent",
            width: "1em",
            height: "1em",
          },
        },
        {
          skillName: "Vercel",
          fontAwesomeClassname: "skill-icons:vercel-light",
          style: {
            color: "gray",
            fill: "gray",
            // backgroundColor: "white",
            width: "1em",
            height: "1em",
          },
        },
        {
          skillName: "Netlify",
          fontAwesomeClassname: "simple-icons:netlify",
          style: {
            color: "#38AFBB",
            width: "1em",
            height: "1em",
          },
        },
        {
          skillName: "Heroku",
          fontAwesomeClassname: "simple-icons:heroku",
          style: {
            color: "#6863A6",
            width: "1em",
            height: "1em",
          },
        },
        {
          skillName: "Firebase",
          fontAwesomeClassname: "simple-icons:firebase",
          style: {
            color: "#FFCA28",
            width: "1em",
            height: "1em",
          },
        },
        // {
        //   skillName: "PostgreSQL",
        //   fontAwesomeClassname: "simple-icons:postgresql",
        //   style: {
        //     color: "#336791",
        //     width: "1em",
        //     height: "1em",
        //   },
        // },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
            width: "1em",
            height: "1em",
          },
        },
        // {
        //   skillName: "Docker",
        //   fontAwesomeClassname: "simple-icons:docker",
        //   style: {
        //     color: "#1488C6",
        //   },
        // },
        {
          skillName: "GitHub Actions",
          fontAwesomeClassname: "simple-icons:githubactions",
          style: {
            color: "#5b77ef",
            width: "1em",
            height: "1em",
          },
        },
      ],
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "Manoharbhai Patel Institute Of Engineering & Technology Shahapur,Bhandara",
      subtitle: "Bachelors Of Computer Engineering",
      logo_path: "amrita_logo.png",
      alt_name: "Nagpur University",
      duration: "2016 - 2020",
      descriptions: [
        "⚡ Founder And General Secretary of Students Union [MIET UNITY].",
        "⚡ Apart from this, I have done courses on Web Development.",
      ],
      website_link: "http://mietbhandara.ac.in/",
    },
    {
      title: "Samarth Mahavidyalaya Lakhani",
      subtitle: "HSC",
      logo_path: "ggsipu_logo.png",
      alt_name: "Nagpur University",
      duration: "2014 - 2016",
      descriptions: [
        "⚡ I have studied HSC (Science) Here",
        // "⚡ Apart from this, I have done courses on Deep Learning, Data Science, Cloud Computing and Full Stack Development."
      ],
      website_link: "https://samarthcollege.ac.in/",
    },
  ],
};

const certifications = {
  certifications: [
    // {
    //   title: "Front-End Developer Capstone",
    //   subtitle: "",
    //   logo_path: "meta_logo.png",
    //   certificate_link:
    //     "",
    //   alt_name: "Meta",
    //   color_code: "#096ce1",
    // },
    // {
    //   title: "Advanced React",
    //   subtitle: "",
    //   logo_path: "meta_logo.png",
    //   certificate_link:
    //     "",
    //   alt_name: "Meta",
    //   color_code: "#096ce1",
    // },
    // {
    //   title: "Java Programming: Build a Recommendation System",
    //   subtitle: "",
    //   logo_path: "duke-logo.jpg",
    //   certificate_link:
    //     "",
    //   alt_name: "Duke University",
    //   color_code: "#001a57",
    // },
    // {
    //   title: "React Basics",
    //   subtitle: "",
    //   logo_path: "meta_logo.png",
    //   certificate_link:
    //     "",
    //   alt_name: "Meta",
    //   color_code: "#096ce1",
    // },
    // {
    //   title: "Programming with JavaScript",
    //   subtitle: "",
    //   logo_path: "meta_logo.png",
    //   certificate_link:
    //     "",
    //   alt_name: "Meta",
    //   color_code: "#096ce1",
    // },
    // {
    //   title: "HTML and CSS in depth",
    //   subtitle: "",
    //   logo_path: "meta_logo.png",
    //   certificate_link:
    //     "",
    //   alt_name: "Meta",
    //   color_code: "#096ce1",
    // },
    // {
    //   title: "Java Programming: Principles of Software Design",
    //   subtitle: "",
    //   logo_path: "duke-logo.jpg",
    //   certificate_link:
    //     "",
    //   alt_name: "Duke University",
    //   color_code: "#001a57",
    // },
    // {
    //   title: "Java Programming: Solving Problems with Software",
    //   subtitle: "",
    //   logo_path: "duke-logo.jpg",
    //   certificate_link:
    //     "",
    //   alt_name: "Duke University",
    //   color_code: "#001a57",
    // },
    // {
    //   title: "Programming Foundations with JavaScript, HTML and CSS",
    //   subtitle: "",
    //   logo_path: "duke-logo.jpg",
    //   certificate_link:
    //     "",
    //   alt_name: "Duke University",
    //   color_code: "#001a57",
    // },
    // {
    //   title: "Android Application Development - II",
    //   subtitle: "- Dr. Adam Porter",
    //   logo_path: "maryland_logo.svg",
    //   certificate_link:
    //     "",
    //   alt_name: "Stanford University",
    //   color_code: "#e11a2b",
    // },
    // {
    //   title: "Android Application Development - I",
    //   subtitle: "- Dr. Adam Porter",
    //   logo_path: "maryland_logo.svg",
    //   certificate_link:
    //     "",
    //   alt_name: "Stanford University",
    //   color_code: "#e11a2b",
    // },
    // {
    //   title: "Fullstack Development",
    //   subtitle: "- Christian Hur",
    //   logo_path: "coursera_logo.png",
    //   certificate_link:
    //     "",
    //   alt_name: "Coursera",
    //   color_code: "#0056d2",
    // },
    // {
    //   title: "ML and AI in GCP",
    //   subtitle: "- GCP Training",
    //   logo_path: "gcp_logo.png",
    //   certificate_link:
    //     "",
    //   alt_name: "GCP",
    //   color_code: "#2fa9508a",
    // },
    // {
    //   title: "Foundational Infrastructure in GCP",
    //   subtitle: "- GCP Training",
    //   logo_path: "gcp_logo.png",
    //   certificate_link:
    //     "",
    //   alt_name: "GCP",
    //   color_code: "#4087f08a",
    // },
    // {
    //   title: "Networking & Security in GCP",
    //   subtitle: "- GCP Training",
    //   logo_path: "gcp_logo.png",
    //   certificate_link:
    //     "",
    //   alt_name: "GCP",
    //   color_code: "#eb40308a",
    // },
    // {
    //   title: "Cloud Computing Fundamentals in GCP",
    //   subtitle: "- GCP Training",
    //   logo_path: "gcp_logo.png",
    //   certificate_link:
    //     "",
    //   alt_name: "GCP",
    //   color_code: "#fabd008a",
    // },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work and Internship",
  description:
    "I've over 1 years of Professional and 3 Years of Personal experience as a Web developer. I've worked on building products as well as my personal projects.",
  header_image_path: "experience.svg",
  sections: {
    title: "Work Experience",
    experiences: [
      {
        title: "Software Engineer",
        company: "Extended Web AppTech LLP",
        company_url: "https://www.extwebtech.com/",
        logo_path: "infosys-logo.png",
        alt_name: "infosys-logo",
        duration: "(Sep, 2022)",
        location: "Hyderabad",
        description:
          "<li>Developed and maintained scalable React JS,  applications for the company's web platform using modern web technologies such as React, Redux, and TypeScript.</li><br><li>Collaborated with cross-functional teams including UX/UI designers, backend developers, and product managers to ensure seamless integration of features and functionality.</li><br><li>Implemented responsive web design principles to ensure optimal performance on different devices and screen sizes.</li><br><li>Actively participated in code reviews, and performed unit and integration testing to ensure code quality and minimize bugs</li>",
        color: "#0071C5",
      },
      {
        title: "Software Engineer",
        company: "Infusion Analysts",
        company_url: "http://www.infusionanalysts.com/",
        logo_path: "infusion.jpg",
        alt_name: "infosys-logo",
        duration: "(2023, 2024)",
        location: "Ahmedabad",
        description:
          "<li>Developed and maintained scalable React JS,Angular applications for the company's web platform using modern web technologies such as React, Redux, and TypeScript.</li><br><li>Collaborated with cross-functional teams including UX/UI designers, backend developers, and product managers to ensure seamless integration of features and functionality.</li><br><li>Implemented responsive web design principles to ensure optimal performance on different devices and screen sizes.</li><br><li>Actively participated in code reviews, and performed unit and integration testing to ensure code quality and minimize bugs</li>",
        color: "#0071C5",
      },
      {
        title: "Web & Mobile Development Intern",
        company: "The Sparks Foundation",
        company_url: "https://www.thesparksfoundationsingapore.org/",
        logo_path: "tsf.png",
        alt_name: "tsf logo",
        duration: "(Jul, 2021 - Aug, 2021)",
        location: "Remote",
        description:
          "Created Basic Banking System website,Donation Website With Payment Gateway Integration,",
        color: "#4285F4",
      },
      {
        title: "Web Development Intern",
        company: "Suven Cosultance And Technology Pvt.Ltd",
        company_url: "https://internship.suvenconsultants.com/",
        logo_path: "suven.png",
        alt_name: "suven logo",
        duration: "(Jun, 2021 - Jul, 2021)",
        location: "Remote",
        description:
          "<li>Created 365 Entertainment similar to Hotstar.com </li> <br/><li>CSS3 Animations</li><br/><li>Blogging-similar to Medium.com</li><br/> <li>Voter Registration – Replica of National Voter Service Portal Form 6</li><br/>",
        color: "#4285F4",
      },
      {
        title: "Web Developer Intern",
        company: "LetsGrowMore",
        company_url: "https://letsgrowmore.in/",
        logo_path: "lgm.png",
        alt_name: "lgm logo",
        duration: "(Aug, 2021 - Sep, 2021)",
        location: "Remote",
        description:
          "<li>Created a Single Page Website using HTML, CSS and JavaScript. </li> <br/><li>Created aWeb Application using Create-React-App. The application had to fetch an API link in order to display the user data.</li><br/>",
        color: "#4285F4",
      },
    ],
  },
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects make use of a vast variety of latest technology tools. My best experience is to create  Projects. Below are some of my projects.",
  avatar_image_path: "projects_image.svg",
};

const projects = {
  data: [
    {
      id: "project-0",
      name: "WorkerPower:On Demand Service For Farmers",
      url: "http://workerpowerr.epizy.com/?i=1",
      repoUrl: "",
      imgUrl:"https://i.ibb.co/p1DVZJh/Screenshot-2023-03-15-at-22-31-27-Worker-Power-On-Demand-Service-For-Farmers.png",
      description:
        "WorkerPower is an innovative on-demand service designed specifically for farmers, offering them a convenient and hassle-free way to manage all their farm-related work. With just a few clicks, farmers can easily order and schedule a wide range of services such as plowing, sowing, harvesting, and much more, all from the comfort of their home.",
      languages: [
        {
          name: "React",
          iconifyClass: "logos:react",
        },
        {
          name: "HTML5",
          iconifyClass: "vscode-icons:file-type-html",
        },
        {
          name: "CSS3",
          iconifyClass: "vscode-icons:file-type-css",
        },
        {
          name: "JavaScript",
          iconifyClass: "logos-javascript",
        },
        {
          name: "Bootstrap",
          iconifyClass: "logos:bootstrap",
        },
        {
          name: "Nodejs",
          iconifyClass: "logos:nodejs",
        },
        {
          name: "MongoDB",
          iconifyClass: "vscode-icons:file-type-mongo",
        },
        {
          name: "Framer Motion",
          iconifyClass: "logos:php",
        },
      ],
    },
    {
      id: "project-1",
      name: "MIETPAY",
      url: "http://mietpay.epizy.com/?i=1",
      repoUrl: "",
      imgUrl:"https://i.ibb.co/rtkD2Vq/Screenshot-2023-03-15-at-22-47-01-Miet-Pay-In.png",
      description:
        "This web-based application aims to provide college students with an easy and convenient way to pay event fees contributions online.",
      languages: [
        {
          name: "React",
          iconifyClass: "logos:react",
        },
        {
          name: "Firebase",
          iconifyClass: "logos:firebase",
        },

        {
          name: "HTML5",
          iconifyClass: "vscode-icons:file-type-html",
        },
        {
          name: "CSS3",
          iconifyClass: "vscode-icons:file-type-css",
        },
        {
          name: "JavaScript",
          iconifyClass: "logos-javascript",
        },
      ],
    },
    {
      id: "project-2",
      name: "LakhoriVeer",
      url: "https://lakhoriveer.netlify.app/",
      imgUrl:"https://i.ibb.co/1KYcWbM/Screenshot-2023-03-15-at-22-52-50-Lakhori-Veer.png",
      repoUrl: "https://lakhoriveer.netlify.app/",
      description:
        "Official Website For My Vilage",
      languages: [
        {
          name: "React",
          iconifyClass: "logos:react",
        },
        {
          name: "HTML5",
          iconifyClass: "vscode-icons:file-type-html",
        },
        {
          name: "CSS3",
          iconifyClass: "vscode-icons:file-type-css",
        },
        {
          name: "JavaScript",
          iconifyClass: "logos-javascript",
        },
        {
          name: "Firebase",
          iconifyClass: "logos:firebase",
        },
        {
          name: "Nodejs",
          iconifyClass: "logos:nodejs",
        },
        {
          name: "Handlebars",
          iconifyClass: "vscode-icons:file-type-handlebars",
        },

      ],
    },
    {
      id: "project-3",
      name: "The Sparks Bank",
      url: "",
      imgUrl:"https://i.ibb.co/2dT5ycL/Screenshot-1.png",
      repoUrl: "",
      description: "Internship Project with A Simple React Banking App  ",
      languages: [
        {
          name: "HTML5",
          iconifyClass: "vscode-icons:file-type-html",
        },
        {
          name: "CSS3",
          iconifyClass: "vscode-icons:file-type-css",
        },
        {
          name: "JavaScript",
          iconifyClass: "logos-javascript",
        },
        {
          name: "React",
          iconifyClass: "logos-react",
        },
      ],
    },
    {
      id: "project-4",
      name: "Portfolio",
      url: "",
      imgUrl:"https://i.ibb.co/yytDNmG/Screenshot-2023-03-15-at-23-09-13-Bhupesh-Portfolio.png",
      repoUrl: "https://github.com/bhupeshkhedikar",
      description: "You are watching it right now 😉.",
      languages: [
        {
          name: "React",
          iconifyClass: "logos-react",
        },
        {
          name: "HTML5",
          iconifyClass: "vscode-icons:file-type-html",
        },
        {
          name: "CSS3",
          iconifyClass: "vscode-icons:file-type-css",
        },
        {
          name: "JavaScript",
          iconifyClass: "logos-javascript",
        },
        {
          name: "React Reveal",
          iconifyClass: "simple-icons:scrollreveal",
        },
        {
          name: "Styled Components",
          iconifyClass: "vscode-icons:file-type-styled",
        },
      ],
    },
  ],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "portfolioProfileImage.png",
    description:
      "You can contact me at the places mentioned below. I will try to get back to you as fast as I can. ",
  },
};

export {
  settings,
  greeting,
  socialMediaLinks,
  skills,
  degrees,
  certifications,
  experience,
  projectsHeader,
  contactPageData,
  projects,
};
